import type { CustomerSegment } from '../types'

export interface HouseNoun {
  singular: string
  plural: string
  possessive: string
}

const STUDENT_NOUN: HouseNoun = {
  singular: 'student',
  plural: 'students',
  possessive: "students'",
}

const JOBSEEKER_NOUN: HouseNoun = {
  singular: 'jobseeker',
  plural: 'jobseekers',
  possessive: "jobseekers'",
}

/**
 * Returns the customer-facing noun for the person the portal serves, based on
 * the workspace's customer segment. Higher-ed workspaces say "students";
 * workforce/bootcamp workspaces say "jobseekers". A workspace with no segment
 * (or "all") defaults to "students".
 */
export function houseNoun(segment: CustomerSegment | null | undefined): HouseNoun {
  if (segment === 'bootcamp_workforce') return JOBSEEKER_NOUN
  return STUDENT_NOUN
}

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

/**
 * Replaces house-noun placeholder tokens in standard-content strings at
 * render time, so the same asset definition reads "students" on a
 * higher-ed workspace and "jobseekers" on a workforce workspace.
 * Tokens: {noun} singular, {Noun} singular capitalized, {nouns} plural,
 * {Nouns} plural capitalized.
 */
export function applyHouseNoun(text: string, segment: CustomerSegment | null | undefined): string {
  if (!text.includes('{')) return text
  const noun = houseNoun(segment)
  return text
    .replace(/\{Nouns\}/g, capitalize(noun.plural))
    .replace(/\{nouns\}/g, noun.plural)
    .replace(/\{Noun\}/g, capitalize(noun.singular))
    .replace(/\{noun\}/g, noun.singular)
}
